import { valtioDevTools } from '@lib/utils/devTools';
import { FrontEndSettingsState } from './types';
import { proxy, subscribe } from 'valtio';

const initialFrontEndSettings: FrontEndSettingsState = {
  followUps: {
    secondChanceLeads: {
      // Use the default setting as fallback in case settings fail to load.
      //
      // This also ensures correct behavior is preserved when the feature flag
      // for SCL settings is disabled, as 7 is the previously-used value, and
      // we won't fetch an updated one when the flag's disabled.
      daysUntilCold: 7,
      isReady: false,
    },
  },
  contactCenterSettings: {
    showWorkflowNameOnInboundCalls: {
      isEnabled: false,
      isReady: false,
    },
    callTimeoutWarning: {
      isEnabled: false,
      isReady: false,
    },
  },
};

export const frontEndSettingsState = proxy<FrontEndSettingsState>(
  initialFrontEndSettings,
);

valtioDevTools(frontEndSettingsState, 'frontEndSettings');

subscribe(frontEndSettingsState, () => {
  console.log('frontEndSettingsState has changed to', frontEndSettingsState);
});
